module.exports = __webpack_public_path__ + "static/media/ic_no_image.1bf22745.svg";